<template>
  <transition name="fade">
    <div class="dialog" v-if="show">
      <div class='dialog-box'>
        <img src="/files/imgs/loading.svg" />
        <div class='dialog-text'>{{msg}}</div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
    name: 'Loading',
    props: {
        show:    Boolean,
        msg:     String
    }
}  
</script>

<style scoped>
.dialog-box {
    text-align: center;
}
</style>
